import React from 'react';

// eslint-disable-next-line no-unused-vars
import errorPageStyles from './errorPageStyles.scss';

export const SomethingWentWrong = location => (
  <section className="error_section">
    <h3 className="error_title_SMR">
      <p id="p">Sorry, Something went wrong</p>
      Sorry, Something went wrong
    </h3>
    <button
      type="button"
      onClick={ () => { window.location.reload(location); } }
      className="btn"
    >
      Reload
    </button>

  </section>

);
